
    import { clsx } from "clsx"
    import { twMerge } from "tailwind-merge"

    export function cn(...inputs) {
      return twMerge(clsx(inputs))
    }

    // Add formatCurrency utility
    export function formatCurrency(amount) {
      if (amount === null || amount === undefined) {
        return '$0.00'; // Or return an empty string or placeholder
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }

    // Add getCreditScoreRating utility
    export function getCreditScoreRating(score) {
      if (score === null || score === undefined) return { rating: 'N/A', colorClass: 'text-muted-foreground' };
      if (score >= 800) return { rating: 'Excellent', colorClass: 'text-green-500' };
      if (score >= 740) return { rating: 'Very Good', colorClass: 'text-green-400' };
      if (score >= 670) return { rating: 'Good', colorClass: 'text-yellow-500' };
      if (score >= 580) return { rating: 'Fair', colorClass: 'text-orange-500' };
      return { rating: 'Poor', colorClass: 'text-red-500' };
    }
  